export const mergeContactRecord = (existing = {}, incoming = {}) => ({
  ...existing,
  ...incoming,
  additional_attributes: {
    ...(existing.additional_attributes || {}),
    ...(incoming.additional_attributes || {}),
  },
  custom_attributes: {
    ...(existing.custom_attributes || {}),
    ...(incoming.custom_attributes || {}),
  },
});

const MEETING_ATTR_KEYS = [
  'demo_timing',
  'meeting_link',
  'demo_subject',
  'meeting_description',
  'event_id',
  'meeting_platform',
  'meeting_provider',
  'reschedule_url',
  'meeting_duration_minutes',
  'demo_lead_user_id',
  'account_manager_user_id',
  'guest_emails',
];

export function buildContactMeetingUiUpdate({
  storeContact = {},
  payload = {},
}) {
  const contactId = payload.contactId;
  if (!contactId) {
    return null;
  }

  const additionalAttributes = {
    ...(storeContact.additional_attributes || {}),
  };

  if (payload.demo_timing !== undefined) {
    additionalAttributes.demo_timing = payload.demo_timing;
  }
  if (payload.meeting_link !== undefined) {
    additionalAttributes.meeting_link = payload.meeting_link;
  }
  if (payload.demo_subject !== undefined) {
    additionalAttributes.demo_subject = payload.demo_subject;
  }
  if (payload.meeting_description !== undefined) {
    if (payload.meeting_description === null) {
      delete additionalAttributes.meeting_description;
    } else {
      additionalAttributes.meeting_description = payload.meeting_description;
    }
  }

  MEETING_ATTR_KEYS.forEach(key => {
    if (Object.prototype.hasOwnProperty.call(payload, key)) {
      if (payload[key] === null || payload[key] === undefined) {
        delete additionalAttributes[key];
      } else {
        additionalAttributes[key] = payload[key];
      }
    }
  });

  const update = {
    id: contactId,
    additional_attributes: additionalAttributes,
  };

  if (payload.primary_contact_meeting_id !== undefined) {
    update.primary_contact_meeting_id = payload.primary_contact_meeting_id;
  }

  if (payload.meeting_starts_at) {
    update.meeting_starts_at = payload.meeting_starts_at;
    if (payload.meeting_ends_at !== undefined) {
      update.meeting_ends_at = payload.meeting_ends_at;
    }
    update.meeting_lifecycle = payload.meeting_lifecycle || 'future';
    update.can_book_meeting = false;
    update.can_reschedule_meeting = true;
    update.can_cancel_meeting = true;
  } else if (payload.meeting_starts_at === null) {
    update.meeting_starts_at = null;
    update.meeting_ends_at = null;
    update.meeting_lifecycle = 'none';
    update.can_book_meeting = true;
    update.can_reschedule_meeting = false;
    update.can_cancel_meeting = false;
    update.primary_contact_meeting_id = null;
    MEETING_ATTR_KEYS.forEach(key => {
      delete additionalAttributes[key];
    });
  }

  return update;
}

export function persistContactMeetingUi(store, payload) {
  const contactId = payload?.contactId;
  if (!contactId || !store) {
    return Promise.resolve();
  }

  const storeContact = store.getters['contacts/getContact'](contactId) || {};
  const update = buildContactMeetingUiUpdate({ storeContact, payload });
  if (!update) {
    return Promise.resolve();
  }

  return store.dispatch('contacts/updateContact', update);
}
